module.exports = __webpack_public_path__ + "img/bg_chat.f04b4fa8.png";